
<template>
  <div class="disFlex" style="margin-top: 20px;min-height: calc(100vh - 160px);padding: 0 20px;">
    <div class="Com-left" :style="collapse?'width:200px;':'width:80px;'">
      <div v-if="collapse">
        <div class="collapse" @click="collapse = false">
          <i class="el-icon-s-fold"></i>收起
        </div>

        <div v-for="(item,i) in menuList">
          <div class="Com-cpdh-item title" v-if="item.type=='2'">
            <span slot="title">{{item.name}}<i class="el-icon-caret-bottom"></i></span>
          </div>
          <div v-if="item.type=='3'" :class="'Com-cpdh-item'+(dhFlag==item.id?' active':'')" @click="changeCom(item.id,item.path)">
             <i :class="item.iconClass"></i>
             <span slot="title">{{item.name}}</span>
           </div>
           <div v-if="item.type=='2'" v-for="(c,n) in item.children" :class="'Com-cpdh-item'+(dhFlag==c.id?' active':'')" @click="changeCom(c.id,c.path)">
             <i :class="c.iconClass"></i>
             <span slot="title">{{c.name}}</span>
           </div>
        </div>

        <!-- <div :class="'Com-cpdh-item'+(dhFlag=='8'?' active':'')" @click="changeCom(8,'/updatePass')">
          <span slot="title"><i class="iconfont icon-mima"></i>修改密码</span>
        </div> -->
      </div>
      <div v-else>
        <div class="collapseZk" @click="collapse = true">
          <el-tooltip class="item" effect="dark" content="展开" placement="right">
            <i class="el-icon-s-unfold" style="font-size: 20px;"></i>
          </el-tooltip>
        </div>

        <div v-for="(item,i) in menuList">
          <div class="Com-sqcpdh-item title" v-if="item.type=='2'">
            <el-tooltip class="item" effect="dark" :content="item.name" placement="right">
              <i class="el-icon-caret-bottom"></i>
            </el-tooltip>
          </div>
          <div v-if="item.type=='3'" :class="'Com-sqcpdh-item'+(dhFlag==item.id?' active':'')" @click="changeCom(item.id,item.path)">
             <el-tooltip class="item" effect="dark" :content="item.name" placement="right">
               <i :class="item.iconClass"></i>
             </el-tooltip>
           </div>
           <div v-if="item.type=='2'" v-for="(c,n) in item.children" :class="'Com-sqcpdh-item'+(dhFlag==c.id?' active':'')" @click="changeCom(c.id,c.path)">
             <el-tooltip class="item" effect="dark" :content="c.name" placement="right">
               <i :class="c.iconClass"></i>
             </el-tooltip>
           </div>
        </div>
        <!-- <div :class="'Com-sqcpdh-item'+(dhFlag=='8'?' active':'')" @click="changeCom(8,'/updatePass')">
          <el-tooltip class="item" effect="dark" content="修改密码" placement="right">
            <i class="iconfont icon-mima"></i>
          </el-tooltip>
        </div> -->
      </div>
    </div>
    <div class="Com-right" :style="collapse?'width:calc(100% - 300px);':'width:calc(100% - 180px);'">
      <router-view @changeCom="changeCom" :collapse="collapse" :wjSrc="wjSrc" :currentUser="currentUser"
        :zyjnList='zyjnList' :zyzclist='zyzclist' />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Learning',
    props: ['wjSrc', 'currentUser', 'zyjnList', 'zyzclist'],
    data() {
      return {
        dhFlag: '0',
        defaultOpen: ['1', '2', '3', '4', '5'],
        collapse: true,
        menuList:[]
      }
    },
    methods: {
      changeCom: function(dhFlag, path) {
        this.dhFlag = dhFlag;
        this.$router.push(path);
      }
    },
    components: {},
    created: function() {
      this.currentUser.menusList.map((item)=>{
        if(item.sid==16){
          this.menuList=item.menus;
        }
      })
    },
    watch: {}
  }
</script>


<style>
  .Com-left {
    width: 200px;
    opacity: 1;
    background: #ffffff;
    border-radius: 4px;
    padding: 20px 0;
    margin-bottom: 20px;
    height: 620px;
    overflow-y: auto;
  }

  .collapse {
    width: 160px;
    height: 40px;
    opacity: 1;
    background: #f6f6f6;
    border-radius: 20px;
    margin: 0 auto 10px;
    line-height: 40px;
    text-align: left;
    font-size: 14px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .collapse i {
    padding-left: 24px;
    padding-right: 8px;
    font-size: 20px;
  }

  .Com-right {
    margin-left: 24px;
  }

  .Com-grxx {
    padding: 28px 0 37px 0;
  }

  .Com-grxx-tx img {
    width: 62px;
    height: 62px;
    border-radius: 50%;
  }

  .Com-grxx-xm {
    margin: 13px 0;
    font-size: 16px;
    font-family: 'PingFangSC';
    font-weight: 500;
    color: #333333;
  }

  .Com-grxx-id {
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    text-align: center;
    color: #9a9a9a;
  }

  .Com-cpdh {}

  .Com-cpdh-item {
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    color: #333333;
    cursor: pointer;
    text-align: left;
    display: flex;
    align-items: center;
    transition: all 0.1s linear;
    width: 160px;
    margin: 5px auto;
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  .Com-cpdh-item.title span {
    padding-left: 24px;
    color: #496079;
  }

  .Com-cpdh-item.title span .el-icon-caret-bottom {
    padding-left: 8px;
    cursor: auto;
  }

  .Com-cpdh-item .iconfont {
    padding-right: 12px;
    font-size: 16px;
    padding-left: 24px;
    color: #000;
  }

  .Com-cpdh-item.active {
    background: #0071ba;
    color: #fff;
    border-radius: 20px;
  }

  .Com-cpdh-item.active .iconfont {
    color: #fff;
  }

  .Com-sqcpdh-item {
    height: 40px;
    width: 40px;
    margin: 5px auto;
    border-radius: 50%;
    line-height: 40px;
    cursor: pointer;
    text-align: center;
  }

  .Com-sqcpdh-item.active {
    background: #0071ba;
    color: #fff;
  }

  .collapseZk {
    width: 40px;
    height: 40px;
    opacity: 1;
    background: #f6f6f6;
    border-radius: 20px;
    margin: 0 auto 10px;
    line-height: 45px;
    text-align: center;
    font-size: 14px;
    cursor: pointer;
  }

  .cominfo-header {
    height: 57px;
    opacity: 1;
    background: #ffffff;
    border-radius: 4px;
    line-height: 57px;
    color: #9a9a9a;
    font-family: 'PingFangSC';
    text-align: left;
    padding-left: 19px;
  }

  .cominfo-header span {
    padding-left: 5px;
    cursor: pointer;
  }

  .cominfo-header span a {
    color: #9a9a9a;
  }

  .cominfo-header span:last-child {
    color: #333;
  }
</style>



// WEBPACK FOOTER //
// src/components/Company.vue